(() => {
  if (window.__BXGY_ENGINE__) return;
  window.__BXGY_ENGINE__ = "buy-x-get-y";

  const giftVariantId = window.giftVariantId ? String(window.giftVariantId) : null;
  let giftProductId = window.giftProductId ? String(window.giftProductId) : null;
  if (!giftVariantId && !giftProductId) return;

  const GIFT_MARKER_KEY = "_auto_gift";
  const GIFT_MARKER_VALUE = "1";
  const GIFT_THRESHOLD_CENTS = Number(window.bxgyThresholdCents || 15000);
  const ADD_COOLDOWN_MS = 4000;

  let isReconciling = false;
  let queued = false;
  let pendingTimer = null;
  let lastAddAt = 0;
  let _engineBusy = false;

  const schedule = (delayMs = 200) => {
    if (_engineBusy) return;
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(() => reconcileCart(), delayMs);
  };

  document.addEventListener("cart:item-added", () => schedule(250));
  document.addEventListener("line-item:change:end", () => schedule(250));

  const cartDrawer = document.getElementById("Cart-Drawer");
  if (cartDrawer) {
    new MutationObserver(() => {
      if (!cartDrawer.hasAttribute("inert")) schedule(150);
    }).observe(cartDrawer, { attributes: true, attributeFilter: ["inert"] });
  }

  schedule(0);

  async function reconcileCart() {
    if (isReconciling) {
      queued = true;
      return;
    }
    isReconciling = true;

    try {
      const cart = await fetchCart();
      if (!giftProductId && giftVariantId) {
        giftProductId = await resolveGiftProductId(giftVariantId);
      }

      const giftItems = [];
      const normalItems = [];
      for (const item of cart.items || []) {
        if (isManagedGiftLine(item)) giftItems.push(item);
        else normalItems.push(item);
      }

      const normalSubtotal = normalItems.reduce((sum, item) => {
        const linePrice =
          typeof item.final_line_price === "number"
            ? item.final_line_price
            : item.line_price || 0;
        return sum + linePrice;
      }, 0);

      const hasNormalItems = normalItems.length > 0;
      const qualifiesForGift = hasNormalItems && normalSubtotal >= GIFT_THRESHOLD_CENTS;
      const hasGift = giftItems.length > 0;

      console.log("[BXGY]", {
        thresholdCents: GIFT_THRESHOLD_CENTS,
        normalSubtotal,
        hasNormalItems,
        hasGift,
        qualifiesForGift,
      });

      if (qualifiesForGift && !hasGift) {
        if (Date.now() - lastAddAt < ADD_COOLDOWN_MS) return;
        await addGiftToCart();
        return;
      }

      if (!qualifiesForGift && hasGift) {
        await removeAllGifts(giftItems);
        return;
      }

      if (qualifiesForGift && hasGift) {
        if (giftItems.length === 1 && giftItems[0].quantity === 1) return;
        await fixGiftDuplicates(giftItems);
      }
    } catch (e) {
      console.error("buy-x-get-y error:", e);
    } finally {
      isReconciling = false;
      if (queued) {
        queued = false;
        schedule(180);
      }
    }
  }

  async function fetchCart() {
    const res = await fetch(`/cart.js?_bxgy=${Date.now()}`, {
      headers: { Accept: "application/json" },
      cache: "no-store",
    });
    return res.json();
  }

  async function resolveGiftProductId(variantId) {
    try {
      const res = await fetch(`/variants/${variantId}.js`, {
        headers: { Accept: "application/json" },
        cache: "no-store",
      });
      if (!res.ok) return null;
      const variant = await res.json();
      return variant?.product_id ? String(variant.product_id) : null;
    } catch (e) {
      return null;
    }
  }

  function isManagedGiftLine(item) {
    const marker = item?.properties?.[GIFT_MARKER_KEY];
    return String(marker || "") === GIFT_MARKER_VALUE;
  }

  function withEngineBusy(fn) {
    return async function (...args) {
      _engineBusy = true;
      try {
        await fn(...args);
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      } finally {
        setTimeout(() => { _engineBusy = false; }, 600);
      }
    };
  }

  const addGiftToCart = withEngineBusy(async function () {
    lastAddAt = Date.now();
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: giftVariantId,
        quantity: 1,
        properties: { [GIFT_MARKER_KEY]: GIFT_MARKER_VALUE },
      }),
    });
  });

  const removeAllGifts = withEngineBusy(async function (giftItems) {
    const updates = {};
    giftItems.forEach((item) => { updates[item.key] = 0; });
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    });
  });

  const fixGiftDuplicates = withEngineBusy(async function (giftItems) {
    const updates = {};
    giftItems.forEach((item, idx) => { updates[item.key] = idx === 0 ? 1 : 0; });
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    });
  });
})();
